/**
 * デッキ管理のタブ（書き出し・撮影と同じ帯）: デッキ（/decks）・要確認（/decks/check）・画像（/decks/images。Issue #958）。
 * 要確認の数は自分で引く（試合に割り当てられているのにメインが 40 枚に足りない版）
 */
import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { api } from '../../api/api';

export default function DeckNav({ incompleteCount = null }) {
  const [count, setCount] = useState(incompleteCount);
  useEffect(() => {
    if (incompleteCount !== null) { setCount(incompleteCount); return; }
    api.project('GetIncompleteDeckAssignments').then((r) => setCount(Array.isArray(r) ? r.length : 0)).catch(() => {});
  }, [incompleteCount]);
  return (
    <nav className="subnav" aria-label="デッキ管理" data-testid="deck-nav">
      <NavLink to="/decks" end data-testid="deck-tab-list">デッキ</NavLink>
      <NavLink to="/decks/check" data-testid="deck-tab-check">要確認{count ? `（${count}）` : ''}</NavLink>
      <NavLink to="/decks/images" data-testid="deck-tab-images">画像</NavLink>
    </nav>
  );
}
